// extracted by mini-css-extract-plugin
export var buttonGenerate = "user-panel-module--button-generate--KPA6x";
export var desktopStylizations = "user-panel-module--desktop-stylizations--UXmmb";
export var introduction = "user-panel-module--introduction--frxEU";
export var leftWrapper = "user-panel-module--left-wrapper--YSyKO";
export var logoBottom = "user-panel-module--logo-bottom--rz8lk";
export var mobileAccordion = "user-panel-module--mobile-accordion--oqnDt";
export var mobileAccordionButton = "user-panel-module--mobile-accordion-button--7GZv3";
export var mobileAccordionButtonActive = "user-panel-module--mobile-accordion-button-active--4de8x";
export var mobileAccordionIcon = "user-panel-module--mobile-accordion-icon--bB27n";
export var mobileAccordionPanel = "user-panel-module--mobile-accordion-panel--4U8-q";
export var mobileAccordionPanelInner = "user-panel-module--mobile-accordion-panel-inner--c2GKo";
export var mobileAccordionPanelOpen = "user-panel-module--mobile-accordion-panel-open--YtQM-";
export var mobileAccountSections = "user-panel-module--mobile-account-sections--76paF";
export var mobileProfileAvatar = "user-panel-module--mobile-profile-avatar--Ha77G";
export var mobileProfileAvatarFallback = "user-panel-module--mobile-profile-avatar-fallback--MU5AM";
export var mobileProfileAvatarImage = "user-panel-module--mobile-profile-avatar-image--EtLMv";
export var mobileSurveyShortcut = "user-panel-module--mobile-survey-shortcut--XVZZS";
export var mobileSurveyShortcutButton = "user-panel-module--mobile-survey-shortcut-button--hmdTK";
export var mobileSurveyShortcutText = "user-panel-module--mobile-survey-shortcut-text--G43LE";
export var ratio = "user-panel-module--ratio--8m09-";
export var rightWrapper = "user-panel-module--right-wrapper--9i2iU";
export var textContent = "user-panel-module--text-content--1drHY";
export var titleText = "user-panel-module--title-text--gI2Qx";
export var userPanel = "user-panel-module--user-panel--ma4n9";
export var welcomeImage = "user-panel-module--welcome-image--zxE+a";